/**
 * Fitnesspilot
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export const HabitAddiction = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
};
export function HabitAddictionFromJSON(json) {
    return HabitAddictionFromJSONTyped(json, false);
}
export function HabitAddictionFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function HabitAddictionToJSON(value) {
    return value;
}
